import { CommonModule, DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, signal, input } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { IonicModule, ModalController } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { AppointmentDto } from "src/app/calendar/interfaces/appointment_dto";
import { updateLesson } from "src/app/calendar/ngrx/calendar.actions";
import { convertAppointment } from "src/app/utils/ConvertAppointments";
import { ModeService } from "src/app/utils/mode.service";
import { AppointmentAddRequest } from '../../../calendar/interfaces/appointment_add_request';

@Component({
    selector: "app-exam-dialog",
    templateUrl: "./exam-dialog.component.html",
    styleUrls: ["./exam-dialog.component.scss"],
    imports: [CommonModule, IonicModule, DatePipe, ReactiveFormsModule, FormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExamDialogComponent implements OnInit {
  readonly lesson = input<AppointmentDto>(undefined);
  examForm: FormGroup;
  isClicked = signal(false);

  constructor(
    public modeService: ModeService,
    private fb: FormBuilder,
    private modalController: ModalController,
    private store: Store<any>,
  ) {
    this.examForm = this.fb.group({
      passed_test: ["", Validators.required],
      education_notes: [""],
    });
  }

  ngOnInit() {
    this.examForm.patchValue({
      passed_test: this.lesson().PassedTest,
      education_notes: this.lesson().EducationNotes,
    });
  }

  save() {
    if (this.examForm.value.passed_test === true) {
      this.isClicked.set(true);
      setTimeout(() => {
        this.modalController.dismiss();
      }, 200);
    } else {
      this.modalController.dismiss();
    }
    let updateLessonRequest =  {
      appointment_id: this.lesson().Id,
      passed_test: this.examForm.value.passed_test,
      education_notes: this.examForm.value.education_notes,
    }

    this.store.dispatch(updateLesson({lesson: updateLessonRequest}));
  }

  cancel() {
    this.modalController.dismiss();
  }
}
